import { render, staticRenderFns } from "./p12.vue?vue&type=template&id=023d20d2&scoped=true&"
import script from "./p12.vue?vue&type=script&lang=js&"
export * from "./p12.vue?vue&type=script&lang=js&"
import style0 from "./p12.vue?vue&type=style&index=0&id=023d20d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d20d2",
  null
  
)

export default component.exports